import { useEffect, useState } from "react";
import { getAboutUs } from "../contentfulService";
import {AboutUsData} from "../types/aboutUsData";

export default function AboutUs() {
    const [data, setData] = useState<AboutUsData | null>(null);

    useEffect(() => {
        getAboutUs().then(setData);
    }, []);

    if (!data) return null;

    return (
        <section id="aboutus" className="py-24 max-w-7xl mx-auto px-8 bg-bgWhite">
            <div className="grid md:grid-cols-2 gap-20 items-center">

                {/* TEXT */}
                <div>
                    <p className="uppercase tracking-widest text-xs text-textMuted mb-4 text-gray-400">
                        {data.description}
                    </p>
                    <h2 className="text-4xl font-serif mb-8">
                        {data.title}
                    </h2>

                    <div className="space-y-6 text-textBody leading-relaxed">
                        {data.text.split("\n\n").map((para, i) => (
                            <p key={i}>{para}</p>
                        ))}
                    </div>
                </div>

                {/* IMAGE */}
                {data.imageUrl && (
                    <div className="w-full h-[420px] overflow-hidden rounded-sm bg-gray-100">
                        <img
                            src={data.imageUrl}
                            alt={data.title}
                            className="w-full h-full object-cover"
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
